import React from 'react';
import { IM90QuoteModule } from '~/lib/data-contract';
import M90 from './m90-quote';

export const M90QuoteBlock = ({ author, quote, id }: IM90QuoteModule) => {
    return <M90 id={id} author={author} quote={quote} />;
};
